/**Dependencies */
import React, { useEffect, useState } from "react";
import { InformationSection } from "../components/InformationSection";
import { infoPayMethods } from "../helpers";
import { Link } from "react-router-dom";
import { calculateBookingDates } from "../helpers";
import { Navigation } from "swiper/modules";

/**Components */
import { PrincipalBanner } from "../components/PrincipalBanner";
import { Swiper, SwiperSlide } from "swiper/react";
import { BannerExperience } from "../components/BannerExperience";
import { PromotionsList } from "../components/PromotionsList";
import { FaPhoneAlt } from "react-icons/fa";

/**Styles */
import "../styles/promociones.scss";

/**Images */
import bannerIngles from "../images/banners/banner-ingles-canada.png";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

// Services
import { elementoPorSeccion } from "../services/adminProductService";

export const Promociones = ({ idElemento = 4 }) => {
  const [imgsBanners, setImgsBanners] = useState([]);
  const { checkIn, checkOut } = calculateBookingDates();
  const [buttonText, setButtonText] = useState("Contácta con tu asesor");

  useEffect(() => {
    const fetchElemento = async () => {
      try {
        const response = await elementoPorSeccion(idElemento);

        const formattedImages = response[1]?.imagenes?.map((img) => ({
          image: img?.url,
          texto: img?.texto,
        }));

        setImgsBanners(formattedImages);
      } catch (err) {
        console.error("Error al cargar las imágenes:", err);
      }
    };

    fetchElemento();
  }, [idElemento]);

  return (
    <div className="promociones">
      <PrincipalBanner idElemento={4} />

      <div className="container py-5">
        <div className="text-center mb-5">
          <h1 className="section-title red">Descubre promociones exclusivas</h1>
        </div>

        <PromotionsList />
      </div>

      <div className="py-5">
        <BannerExperience />
      </div>

      <div className="py-5 container">
        <div className="text-center mb-5">
          <h1 className="section-title ">
            Destinos favoritos de nuestros viajeros
          </h1>
        </div>
        <div className="slider-container carousel-container">
          <div className="custom-prev" id="prev-destination">
            <IoIosArrowBack />
          </div>
          <Swiper
            navigation={{
              nextEl: "#next-destination",
              prevEl: "#prev-destination",
            }}
            modules={[Navigation]}
            spaceBetween={35}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 3.2,
              },
            }}
          >
            {imgsBanners?.map((image, index) => (
              <SwiperSlide key={index}>
                <Link
                  to={`/alojamientos?t=destino&id=${image?.texto}&in=${checkIn}&out=${checkOut}&hab=1&pax1=2|0|0`}
                >
                  <img
                    src={`https://panel.internationaltravelnet.com.mx/assets/uploads/elementos/${image?.image}`}
                    alt={`Imagen ${index + 1}`}
                    style={{ width: "100%", height: "500px" }}
                  />
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="custom-next" id="next-destination">
            <IoIosArrowForward />
          </div>
        </div>
      </div>

      <div>
        <InformationSection arrInfo={infoPayMethods} />
      </div>
      <div className="banner-ingles pt-5">
        <img src={bannerIngles} alt="Fondo de banner" />
        <div className="contenido">
          <button
            className="boton-contacto btn-blue"
            onMouseEnter={() => setButtonText("777 179 0074")}
          >
            <a
              href="tel:+7772035097"
              style={{ textDecoration: "none", color: "white" }}
            >
              <FaPhoneAlt /> {buttonText}
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};
